import Tr from 'translations/Translations';
import {createSelectItem} from "components/Select";

export const AuctionType = {
    TEST: "TEST",
    PROD: "PROD"
}
const _TR_PREFIX = 'auction_type_';

export const AuctionTypeLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));

export const AuctionTypeItems = [
    createSelectItem(AuctionType.PROD, AuctionTypeLabel(AuctionType.PROD)),
    createSelectItem(AuctionType.TEST, AuctionTypeLabel(AuctionType.TEST))
]

